const team = {
  header: {
    title: "تیم و دسترسی به فضای کاری",
    description: "هر عضو یک فضای کاری مستقل برای مدیریت و انتشار محتوا دارد: منابع، فیلترها، تنظیمات هوش مصنوعی، پست‌های پایش‌شده، صندوق محتوا، وضعیت بررسی، تاریخچه انتشار، اعتبار ربات تلگرام و مقصدهای مخصوص خود. مدیریت تیم و تنظیمات سیستم فقط در اختیار مدیر ارشد است.",
    currentAdministrator: "مدیر فعلی سیستم",
    superAdminFallback: "مدیر ارشد",
  },
  isolation: {
    inboxTitle: "صندوق محتوای خصوصی",
    inboxDescription: "ویرایش‌ها، تأییدها، بایگانی، نتایج انتشار و تاریخچه فقط متعلق به همان عضو هستند.",
    destinationsTitle: "مقصدهای خصوصی",
    destinationsDescription: "هر عضو اعتبار ربات تلگرام و فهرست مقصد جداگانه دارد.",
    setupTitle: "تنظیمات پردازش خصوصی",
    setupDescription: "هر عضو منابع، فیلترها، ترجیحات هوش مصنوعی و سوابق پست‌های پایش‌شده جداگانه خود را کنترل می‌کند.",
  },
  form: {
    title: "افزودن عضو فضای کاری",
    description: "حساب‌های جدید از Supabase Auth استفاده می‌کنند و یک فضای کاری شخصی جداگانه می‌گیرند.",
    email: "ایمیل",
    emailPlaceholder: "member@example.com",
    emailHelp: "ایمیل به شناسه پایدار Supabase برای جداسازی داده‌های شخصی تبدیل می‌شود.",
    password: "رمز عبور موقت",
    passwordPlaceholder: "حداقل ۸ نویسه",
    role: "نقش دسترسی",
    roles: {
      adminOption: "مدیر — مدیریت و انتشار شخصی",
      superAdminOption: "مدیر ارشد — فضای شخصی + مدیریت سیستم",
      adminTitle: "دسترسی مدیر",
      superAdminTitle: "دسترسی مدیر ارشد",
      adminDescription: "منابع، فیلترها، ترجیحات هوش مصنوعی، پست‌های پایش‌شده، صندوق محتوا، مقصدها و تاریخچه انتشار خصوصی دریافت می‌کند.",
      superAdminDescription: "یک فضای مدیریت محتوای کاملاً خصوصی به‌علاوه اجازه مدیریت اعضای تیم و سلامت سیستم دریافت می‌کند.",
    },
    submit: "ایجاد عضو فضای کاری",
    submitting: "در حال ایجاد عضو…",
  },
  feedback: {
    validEmail: "یک ایمیل معتبر وارد کنید. اعضای جدید از Supabase Auth استفاده می‌کنند.",
    passwordLength: "رمز عبور موقت باید حداقل ۸ نویسه باشد.",
    provisionSuccess: "عضو “{{identity}}” با فضای مدیریت و انتشار کاملاً خصوصی ایجاد شد.",
    provisionFailed: "ایجاد این عضو فضای کاری ممکن نشد.",
    revokeConfirm: "دسترسی “{{identity}}” لغو شود؟ منابع، فیلترها، ترجیحات هوش مصنوعی، پست‌های پایش‌شده، صندوق محتوا، مقصدها و تاریخچه انتشار برای ممیزی/بازیابی حفظ می‌شوند، اما دیگر امکان ورود نخواهد داشت.",
    revokeSuccess: "دسترسی “{{identity}}” لغو شد. داده‌های فضای کاری شخصی حفظ شدند.",
    revokeFailed: "لغو دسترسی ممکن نشد. مطمئن شوید دسترسی خودتان یا آخرین مدیر ارشد را لغو نمی‌کنید.",
    revokeAccountFailed: "لغو دسترسی این حساب ممکن نشد.",
  },
  members: {
    title: "اعضای فضای کاری",
    summary: "{{active}} فعال · {{total}} کل",
    legacySuffix: " · {{legacy}} قدیمی",
    isolationEnabled: "جداسازی فضای کاری شخصی فعال است",
    legacyTitle: "حساب‌های قدیمی هنوز وجود دارند",
    legacyDescription: "این حساب‌ها همچنان سازگارند و از نام کاربری نرمال‌شده به‌عنوان کلید فضای کاری شخصی استفاده می‌کنند. اعضای جدید بهتر است با ایمیل ساخته شوند تا مالکیت به شناسه تغییرناپذیر Supabase متصل باشد.",
    you: "شما",
    roles: {
      superAdmin: "مدیر ارشد",
      admin: "مدیر",
    },
    status: {
      active: "فعال",
      revoked: "لغوشده",
    },
    added: "افزوده‌شده در {{date}}",
    providers: {
      supabase: "Supabase Auth",
      legacy: "شناسه قدیمی",
    },
    privateWorkspace: "صندوق محتوا + مقصدهای خصوصی",
    legacyWarning: "مالکیت فضای کاری قدیمی بر پایه نام کاربری است. برای اعضای جدید از حساب ایمیل/Supabase استفاده کنید.",
    revoke: "لغو دسترسی",
    emptyTitle: "عضوی پیدا نشد",
    emptyDescription: "اولین حساب را از فرم ایجاد کنید.",
  },
} as const;

export default team;
